import { formStructureApi } from "api/TenantSlug/FormStructure/api.ts";
import { useSelectOptions } from "components/UI/Selects/SearchableSelect/hooks/useSelectOptions.ts";

import FilterRequest = App.Http.Requests.FilterRequest;
import FormStructureData = App.Data.FormStructureData;
import GetFormStructuresRequest = App.Http.Requests.FormStructure.GetFormStructuresRequest;

interface Args {
    filter?: FilterRequest;
    useSystemNameAsValue?: boolean;
}

export const useFormStructureSelectOptions = ({ filter, useSystemNameAsValue = false }: Args = {}) => {
    const queryParams: GetFormStructuresRequest = {
        filter: {
            sort: "system_name",
            ...filter,
        },
    };

    return useSelectOptions<FormStructureData>({
        apiFunction: (payload) => formStructureApi.index(payload),
        dataKey: "formStructures",
        cacheKey: "form-structure-select",
        queryParams: queryParams,
        mapToOption: (formStructure) => ({
            label: formStructure.system_name,
            value: useSystemNameAsValue
                ? (formStructure.system_name ?? formStructure.id?.toString() ?? "")
                : (formStructure.id?.toString() ?? ""),
        }),
    });
};
